<template>
  <v-container fluid class="px-md-1" style="padding-top: 100px">
    <div v-if="show == true" id="cargando" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
      <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-card class="mt-2" v-if="mostrarlistado">
      <v-card-title class="pa-5 pb-3 primary">
        <v-icon class="pr-3" color="white">mdi-magnify</v-icon>
        <p style="color: white">Búsqueda General</p>
      </v-card-title>
      <v-card-text>
        <div class="table-responsive">
          <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-for="encabezado in headers" :key="encabezado.id">
                  {{ encabezado.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reporte in reportes" :key="reporte.id">
                <td></td>
                <td v-if="reporte.aiclave == 1 || reporte.aiclave == 24 || reporte.aiclave == 23 || reporte.aiclave == 5">
                  <a class="link" @click="BuscarReporte(reporte)">{{
                    reporte.nrreporte
                  }}</a>
                </td>
                <td v-else>{{ reporte.nrreporte }}</td>
                <td>{{ reporte.svnumsin }}</td>
                <td>{{ reporte.ainombre }}</td>
                <td>{{ reporte.esnombre }}</td>
                <td>{{ reporte.asnombre }}</td>
                <td>{{ reporte.svfhreporte }}</td>
                <td>{{ reporte.svfhconclusion }}</td>
                <td>{{ reporte.svfhsiniestro }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import SerBusqueda from "@/services/busqueda/busqueda.service.js";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

export default {
  data: function () {
    return {
      headers: [
        { text: "Reporte Ind", value: "nrreporte", class: "text title" },
        { text: "Número de Siniestro", value: "svnumsin", class: "text title" },
        { text: "Asistencia", value: "ainombre", class: "text title" },
        { text: "Estado", value: "esnombre", class: "text title" },
        { text: "Asegurado", value: "asnombre", class: "text title" },
        { text: "Fecha del Reporte", value: "svfhreporte", class: "text title", },
        { text: "Fecha de Conclusión", value: "svfhconclusion", class: "text title", },
        { text: "Fecha de Siniestro", value: "svfhsiniestro", class: "text title", },
      ],
      reportes: [],
      show: false,
      mostrarlistado: false,
      prefix: "tabla_",
      randomNum: Math.floor(Math.random() * 1000),
    };
  },
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    tableName() {
      return this.prefix + this.randomNum;
    },
  },
  methods: {
    async BuscarReporte(item) {
      let aux = item.nrreporte.split("-");
      let _svindice = aux[1];
      let _nrreporte = aux[0];

      let reporte = {
        nrreporte: _nrreporte,
        svindice: _svindice,
        aiclave: item.aiclave,
        svfhconclusion: item.svfhconclusion,
      };
      let routerName = MetodosGenerales.obtenerRouterName(
        parseInt(item.aiclave)
      );
      await MetodosGenerales.guardarEnSesionInfoReporte(reporte, "reporte");
      let url = this.$router.resolve({ name: `${routerName}`, params: { id: 0, } });
      window.open(url.href, '_blank');

    },
    async BusquedaSiniestro(siniestro) {
      this.mostrarlistado = false;
      this.show = true;
      this.reportes = [];
      $("#" + this.tableName + "_paginate").empty();
      $("#" + this.tableName + "_info").remove();
      $("#" + this.tableName + "_filter").remove();
      this.randomNum = Math.floor(Math.random() * 1000);

      let response = await SerBusqueda.BusquedaPorSiniestro(this, siniestro)
      let auxbusqueda = response;
      if (typeof auxbusqueda !== "undefined") {
        for (let i in auxbusqueda) {
          for (const [key, value] of Object.entries(auxbusqueda[i])) {
            if (typeof value == "object") {
              auxbusqueda[i][key] = "";
            } else {
              auxbusqueda[i][key] = value.toString();
            }
          }
        }
        this.reportes = auxbusqueda;
        for (let i in this.reportes) {
          this.reportes[i].nrreporte =
            this.reportes[i].nrreporte + "-" + this.reportes[i].svindice;
        }
        setTimeout(() => {
          $(`#${this.tableName}`).DataTable({
            dom: "iftlp",
            lengthMenu: [
              [20, 50, 100],
              [20, 50, 100],
            ],
            paginate: true,
            pageLength: 20,
            responsive: {
              details: {
                type: 'column'
              }
            },
            columnDefs: [{
              className: 'dtr-control',
              orderable: false,
              targets: 0
            }],
            order: [1, 'asc'],
            language: {
              sProcessing: "Procesando...",
              sLengthMenu: "Mostrar _MENU_ registros",
              sZeroRecords: "No se encontraron resultados",
              sEmptyTable: "Sin registros encontrados",
              sInfo: "",
              sInfoEmpty: "",
              sInfoFiltered: "",
              sInfoPostFix: "",
              search: "",
              searchPlaceholder: "Filtrar...",
              sUrl: "",
              sInfoThousands: ",",
              sLoadingRecords: "Cargando...",
              oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "&raquo;",
                sPrevious: "&laquo;",
              },
              oAria: {
                sSortAscending:
                  ": Activar para ordenar la columna de manera ascendente",
                sSortDescending:
                  ": Activar para ordenar la columna de manera descendente",
              },
            },
          });
        });
        this.reportes = auxbusqueda;
        this.show = false;
        this.mostrarlistado = true;
      }
    },
  },
  mounted() {
    let sinisestro = this.$route.params.data;
    if (typeof sinisestro !== "undefined") {
      this.BusquedaSiniestro(sinisestro);
    }
    this.$root.$on("busquedaSiniestro", (data) => {
      this.BusquedaSiniestro(data);
    });
  },
};
</script>

